import { privateClient } from './client';

const requestCreditCardChange = (sessionId, card, cvv) =>
  privateClient(sessionId).post(`/v1/card/change`, { card, cvv });

export { requestCreditCardChange };
